var play_icon_default = {
  "shadow": "nz8Oz",
  "playIcon": "SWMQe"
};
export {
  play_icon_default as default
};
//# sourceMappingURL=play-icon-scss.js.map
